import { ComponentType } from 'react';
import { GroupProps } from 'react-select';
import { SelectOption, SelectOptionGroup } from '../../types';
import {
  DropdownMenuSectionSplit,
  DropdownMenuSectionTitle,
  OptionDescription,
} from '@ardoq/dropdown-menu-ui';
import { Icon } from '@ardoq/icons';

export const Group: ComponentType<
  GroupProps<SelectOption<unknown>, false, SelectOptionGroup<unknown>>
> = ({ label, data, children }) => (
  <>
    {label && (
      <DropdownMenuSectionTitle>
        {data.leftIcon && (
          <Icon iconName={data.leftIcon.name} color={data.leftIcon.color} />
        )}
        {label}
      </DropdownMenuSectionTitle>
    )}
    {data.description && (
      <OptionDescription>{data.description}</OptionDescription>
    )}
    {children}
    <DropdownMenuSectionSplit />
  </>
);
